import { useState } from 'react';

import RetryNotification from '../RetryNotification/RetryNotification';
import RetryPaymentLoader from '../RetryPaymentLoader/RetryPaymentLoader';

import PayPalRetryButton from '@features/PayPal/PayPalRetryButton/PayPalRetryButton';
import { useTranslation } from '@hooks/useTranslations';

import styles from './RetryPaymentPaypal.module.scss';

export type RetryPaymentPaypalProps = {
  currency: string;
  amount: number;
  orderId: string;
  siteId: number;
  sid?: string;
  customerId?: string;
};

const RetryPaymentPaypal = ({
  currency,
  sid,
  customerId,
  amount,
  orderId,
  siteId,
}: RetryPaymentPaypalProps) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  return (
    <div className={styles.retryPaypalPayment}>
      {loading && <RetryPaymentLoader />}

      <RetryNotification
        sid={sid}
        currency={currency}
        siteId={siteId}
        customerId={customerId}
        id="retryPaymentNotification"
        ariaLabel={t('mzp.order.detail.retry.payment.accessibility.label')}
        type="warning">
        {t('mzp.order.detail.payment.reminder.warning', {
          0: t('mzp.order.detail.retry.payment.button', {
            0: t('general.payment.paypal'),
          }),
        })}
        <div
          className={styles.retryPaypalPaymentButtonContainer}
          data-zta="retryPaypalPaymentContainer">
          <PayPalRetryButton
            currency={currency}
            orderId={orderId}
            setLoading={setLoading}
            amount={amount}
            siteId={siteId}
          />
        </div>
      </RetryNotification>
    </div>
  );
};

export default RetryPaymentPaypal;
